import useSWR, { KeyedMutator } from "swr";
import {
  EntityFieldItem,
  EntityFieldsResponse,
  getEntityFields,
} from "../services/cleaning-data-service";

export interface UseTableFieldsReturn {
  fields: EntityFieldItem[] | undefined;
  isLoading: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any;
  mutate: KeyedMutator<EntityFieldsResponse | null>;
}

const useTableFields = (tableId?: number): UseTableFieldsReturn => {
  const { data, error, mutate } = useSWR(
    tableId ? `/fields/${tableId}` : null,
    () => (tableId ? getEntityFields(tableId) : null),
  );

  return {
    fields: data?.results,
    isLoading: !error && !data && tableId !== undefined,
    error,
    mutate,
  };
};

export default useTableFields;
